/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Commons_Error_Page_Copy_FailedInputs */

const de_commons_error_page_copy_failed = /** @type {(inputs: Commons_Error_Page_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopieren fehlgeschlagen`)
};

/** @type {(inputs: Commons_Error_Page_Copy_FailedInputs) => LocalizedString} */
const en_commons_error_page_copy_failed = de_commons_error_page_copy_failed;

/**

* @param {Commons_Error_Page_Copy_FailedInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const commons_error_page_copy_failed = /** @type {((inputs?: Commons_Error_Page_Copy_FailedInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Commons_Error_Page_Copy_FailedInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_commons_error_page_copy_failed(inputs)
	return en_commons_error_page_copy_failed(inputs)
});